import React, { useEffect } from 'react'
import { Row, Col } from 'shards-react'
import PasswordForm from '../../components/password-form/PasswordForm'
import useForm from '../../hooks/useForm'
import logo_card from '../../images/avatars/lock.svg'
import AuthService from '../../services/auth-service/AuthService'
import ErrorHandler from '../../utils/ErrorHandler'
import PropTypes from 'prop-types'
import { PasswordViewContainer, CustomizedAlert, FormAuthConatiner } from './style'
import { useNavigate, useParams } from 'react-router-dom'
import useCurrentPath from '../../hooks/useCurrentPath'

const RedefinePassword = () => {
    const initialState = {
        isFetching: false,
        hasError: false,
        msgError: '',
        currentPassword: '',
        newPassword: '',
        newPasswordConfirmation: '',
        success: false,
        showBackLink: false,
        score: 0,
    }

    const { values, setValue, setAllValues } = useForm(initialState)

    const informations = {
        isFetching: values.isFetching,
        hasError: values.hasError,
        msgError: values.msgError,
        src: logo_card,
    }

    const infoFirstInput = {
        type: 'password',
        label: 'Nova Senha',
        name: 'newPassword',
        value: values.newPassword,
        valid: values.newPassword && values.newPassword === values.newPasswordConfirmation ? true : false,
    }

    const infoSecondtInput = {
        type: 'password',
        label: 'Confirmar Nova Senha',
        name: 'newPasswordConfirmation',
        value: values.newPasswordConfirmation,
        valid: values.newPasswordConfirmation && values.newPasswordConfirmation === values.newPassword ? true : false,
    }

    const configButton = {
        theme: 'primary',
        label: 'Redefinir senha',
    }

    const navigate = useNavigate()
    const params = useParams()
    const currentPath = useCurrentPath()

    useEffect(() => {
        const isAbleToRedefinePassword =
            currentPath &&
            currentPath &&
            (currentPath === '/redefine_password/:token' || currentPath === '/manager/redefine_password/:token')

        if (!isAbleToRedefinePassword) {
            navigate({ pathname: '/' })
        }
    }, [])

    const redefinePassword = event => {
        event.preventDefault()
        setAllValues({ ...values, ...{ msgError: '', hasError: false, isFetching: true, showBackLink: false } })
        const { newPassword, newPasswordConfirmation, score } = values

        if (score <= 1) {
            setAllValues({
                ...values,
                ...{
                    // eslint-disable-next-line quotes
                    msgError: "Senhas com os status 'muito fraca' ou 'fraca' não são permitidas.",
                    hasError: true,
                    success: false,
                    isFetching: false,
                },
            })
            return
        }

        if (!newPassword) {
            setAllValues({
                ...values,
                ...{
                    msgError: 'É necessário informar a nova senha.',
                    hasError: true,
                    success: false,
                    isFetching: false,
                },
            })
            return
        }

        if (newPasswordConfirmation !== newPassword) {
            setAllValues({
                ...values,
                ...{
                    msgError:
                        'O campo Confirmar Nova Senha deve ser preenchido, de forma identica ao campo Nova Senha.',
                    hasError: true,
                    success: false,
                    isFetching: false,
                },
            })
            return
        }

        const { token } = params
        AuthService.resetPassword(token, newPassword)
            .then(() => {
                setAllValues({
                    ...values,
                    ...{ success: true, hasError: false, isFetching: false, showBackLink: true },
                })
            })
            .catch(e => {
                setAllValues({
                    ...values,
                    ...{
                        msgError: 'Não foi possível alterar a senha.',
                        success: false,
                        hasError: true,
                        isFetching: false,
                        showBackLink: true,
                    },
                })
                ErrorHandler.handleError(e)
            })
    }

    const changeScore = score => {
        const valuesDeepClone = JSON.parse(JSON.stringify(values))
        valuesDeepClone.score = score
        setAllValues(valuesDeepClone)
    }

    const actions = {
        formSubmit: redefinePassword,
        onchange: setValue,
        onChangeScore: changeScore,
    }

    return (
        <PasswordViewContainer>
            <Row>
                <Col sm="12">
                    {values.success ? (
                        <CustomizedAlert id={'cypress-redefine-password-alert'} theme="success">
                            Senha alterada com sucesso.
                        </CustomizedAlert>
                    ) : null}
                </Col>
                <Col sm="12">
                    {values.hasError ? <CustomizedAlert theme="danger">{values.msgError}</CustomizedAlert> : null}
                </Col>
            </Row>
            <FormAuthConatiner>
                <PasswordForm
                    screen="createNewPassword"
                    showIcon={true}
                    informations={informations}
                    showBrand={false}
                    configFirstInput={infoFirstInput}
                    configSecondtInput={infoSecondtInput}
                    configButton={configButton}
                    message="Redefinindo a senha..."
                    actions={actions}
                    showBackLink={values.showBackLink}
                />
            </FormAuthConatiner>
        </PasswordViewContainer>
    )
}

RedefinePassword.propTypes = {
    match: PropTypes.object,
    history: PropTypes.any,
}

export default RedefinePassword
